/**
 * SMB Component - carousel
 * @copyright 2018 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2018-07
 *
 * DESCRIPTION:
 * Basic functionality of carousel
 *
 * OPTIONS:
 * 
 *
 * USAGE EXAMPLE:
 * 
 */

"use strict";

$(document).ready(function () {

    //jQuery Elements
    var $item = $('.carousel__item'),        
        $controlPrev = $('.js-carousel-control-left'),
        $controlNext = $('.js-carousel-control-right'),
        $title = $('.js-carousel-title'),
        
        mainId = 2, //Index of front element
        classItemId = 'carousel__item_id';
        

    //set data index to all items when ready
    $item.each( function( index, element ){
       $(this).attr('data-index', index)           
    });
    
    
    //function update Title from alt 
    var updateText = function(mainId) {
        var text = $('.'+classItemId+mainId).children('img').attr('alt');        
        $title.text(text); 
    }
    //Function Update class 
    var updateClass = function(that, index) {
        that.attr('data-index', index);                      
        var itemClass = that.attr("class").match(/carousel__item_id[\w-]*\b/).toString(); //get origin class with id        
        that.removeClass(itemClass).addClass(classItemId+index); //replace class with id                        
    }        
            
        
    //handlers
    $controlPrev.on('click', function(e) {    
        e.preventDefault();
        $item.each( function() {
           var index = parseInt($(this).attr('data-index')) + 1;           
           index >= $item.length ? index = 0 : null;
           updateClass($(this), index);
           updateText(mainId);           
        });                              
    });
    
    $controlNext.on('click', function(e) { 
        e.preventDefault();       
        $item.each( function() {
           var index = parseInt($(this).attr('data-index')) - 1;           
           index < 0 ? index = ($item.length - 1) : null;     
           updateClass($(this), index);                        
           updateText(mainId);
        });                              
    });    
});